module.exports = require('./helpers/bundle-url').getBundleURL('hRXdN') + "epa-ch4emission-yeargrid-v2express.thumbnails.total.agriculture.annual.a102536b.png";